import { render, staticRenderFns } from "./RoleServer.vue?vue&type=template&id=c40b07b0&scoped=true&"
import script from "./RoleServer.vue?vue&type=script&lang=js&"
export * from "./RoleServer.vue?vue&type=script&lang=js&"
import style0 from "./RoleServer.vue?vue&type=style&index=0&id=c40b07b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40b07b0",
  null
  
)

export default component.exports